import { render, staticRenderFns } from "./ReportsColumnTwoAxisChart.vue?vue&type=template&id=630e1f4d"
import script from "./ReportsColumnTwoAxisChart.vue?vue&type=script&lang=js"
export * from "./ReportsColumnTwoAxisChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports